module.exports = __webpack_public_path__ + "img/dlx.122e0786.svg";